import React from 'react';
import { Helmet } from 'react-helmet';
import OrderHistory from '../components/OrderHistory';

const OrderHistoryPage = () => {
  return (
    <>
      {' '}
      <Helmet>
        <title>Orders</title>
      </Helmet>
      <OrderHistory />{' '}
    </>
  );
};

export default OrderHistoryPage;
